export const cardData = [
  {
    name: 'club_1',
    rule: ` Ace is for waterfall`
  },
  {
    name: 'club_2',
    rule: '2 is for you'
  },
  {
    name: 'club_3',
    rule: '3 is for me'
  },
  {
    name: 'club_4',
    rule: '4 is for floor'
  },
  {
    name: 'club_5',
    rule: '5 is for guys'
  },
  {
    name: 'club_6',
    rule: '6 is for chicks'
  },
  {
    name: 'club_7',
    rule: '7 is for heaven'
  },
  {
    name: 'club_8',
    rule: '8 is for a mate'
  },
  {
    name: 'club_9',
    rule: '9 is for rhyme'
  },
  {
    name: 'club_10',
    rule: '10 is for categories'
  },
  {
    name: 'club_jack',
    rule: 'Jack is thumb master'
  },
  {
    name: 'club_queen',
    rule: 'Queen is question master'
  },
  {
    name: 'club_king',
    rule: 'King is for rules'
  },
  {
    name: 'diamond_1',
    rule: ` Ace is for waterfall`
  },
  {
    name: 'diamond_2',
    rule: '2 is for you'
  },
  {
    name: 'diamond_3',
    rule: '3 is for me'
  },
  {
    name: 'diamond_4',
    rule: '4 is for floor'
  },
  {
    name: 'diamond_5',
    rule: '5 is for guys'
  },
  {
    name: 'diamond_6',
    rule: '6 is for chicks'
  },
  {
    name: 'diamond_7',
    rule: '7 is for heaven'
  },
  {
    name: 'diamond_8',
    rule: '8 is for a mate'
  },
  {
    name: 'diamond_9',
    rule: '9 is for rhyme'
  },
  {
    name: 'diamond_10',
    rule: '10 is for categories'
  },
  {
    name: 'diamond_jack',
    rule: 'Jack is thumb master'
  },
  {
    name: 'diamond_queen',
    rule: 'Queen is question master'
  },
  {
    name: 'diamond_king',
    rule: 'King is for rules'
  },
  {
    name: 'heart_1',
    rule: ` Ace is for waterfall`
  },
  {
    name: 'heart_2',
    rule: '2 is for you'
  },
  {
    name: 'heart_3',
    rule: '3 is for me'
  },
  {
    name: 'heart_4',
    rule: '4 is for floor'
  },
  {
    name: 'heart_5',
    rule: '5 is for guys'
  },
  {
    name: 'heart_6',
    rule: '6 is for chicks'
  },
  {
    name: 'heart_7',
    rule: '7 is for heaven'
  },
  {
    name: 'heart_8',
    rule: '8 is for a mate'
  },
  {
    name: 'heart_9',
    rule: '9 is for rhyme'
  },
  {
    name: 'heart_10',
    rule: '10 is for categories'
  },
  {
    name: 'heart_jack',
    rule: 'Jack is thumb master'
  },
  {
    name: 'heart_queen',
    rule: 'Queen is question master'
  },
  {
    name: 'heart_king',
    rule: 'King is for rules'
  },
  {
    name: 'spade_1',
    rule: ` Ace is for waterfall`
  },
  {
    name: 'spade_2',
    rule: '2 is for you'
  },
  {
    name: 'spade_3',
    rule: '3 is for me'
  },
  {
    name: 'spade_4',
    rule: '4 is for floor'
  },
  {
    name: 'spade_5',
    rule: '5 is for guys'
  },
  {
    name: 'spade_6',
    rule: '6 is for chicks'
  },
  {
    name: 'spade_7',
    rule: '7 is for heaven'
  },
  {
    name: 'spade_8',
    rule: '8 is for a mate'
  },
  {
    name: 'spade_9',
    rule: '9 is for rhyme'
  },
  {
    name: 'spade_10',
    rule: '10 is for categories'
  },
  {
    name: 'spade_jack',
    rule: 'Jack is thumb master'
  },
  {
    name: 'spade_queen',
    rule: 'Queen is question master'
  },
  {
    name: 'spade_king',
    rule: 'King is for rules'
  }
]
